export default {
  TESTETELEGRAM (state, info) {
    state.testetelegram = info  
  },
  BUSCATELEGRAM (state, info) {
    state.idTelegram = info.CodigoTelegram
  },
  UPDATEMESSAGE (state, message) {
    state.idTelegram = message
  },
  GRAVATELEGRAM (state, mensagem) {
    state.telegramMensagem = mensagem
  }
}